import { render } from "./conselho.vue?vue&type=template&id=d1bf7268"
import script from "./conselho.vue?vue&type=script&lang=js"
export * from "./conselho.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__